<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :maskClosable="false">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="用户ID｛zb_user.id｝" prop="userId" >-->
<!--        <a-input v-model="form.userId" placeholder="请输入用户ID｛zb_user.id｝" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="医师认证ID｛zb_doctor_auth.id｝" prop="doctorAuthId" >-->
<!--        <a-input v-model="form.doctorAuthId" placeholder="请输入医师认证ID｛zb_doctor_auth.id｝" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="医院" prop="hospitalId" >
        <a-input-search
          v-model="hospitalName"
          placeholder="请选择医院"
          enter-button="选择"
          @search="handleSelectHospital"
          :readonly="true"
        />
        <!-- 医院选择弹窗 -->
        <table-select-modal
          :visible.sync="hospitalSelectVisible"
          title="选择医院"
          :api-method="pageHospital"
          :columns="hospitalColumns"
          search-label="医院名称"
          search-key="hospitalName"
          search-placeholder="请输入医院名称"
          :data-path="'data.records'"
          :total-path="'data.total'"
          @ok="handleHospitalSelected"
          @cancel="handleHospitalCancel"
        >
        </table-select-modal>
      </a-form-model-item>
      <a-form-model-item label="科室" prop="departId" >
        <a-select v-model="form.departId" placeholder="请选择科室">
          <a-select-option v-for="item in departList" :value="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="姓名" prop="name" >
        <a-input v-model="form.name" placeholder="请输入姓名" />
      </a-form-model-item>
      <a-form-model-item label="性别" prop="sex" >
        <a-select v-model="form.sex" placeholder="请选择">
          <a-select-option v-for="item in dict.type['sys_user_sex']" :value="Number(item.value)" :key="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="行医资质证明" prop="certify" >
        <file-upload type="image" :defaultList="form.certifyArr" :count="1"
                     @input="getImg($event, 'certify')"/>
      </a-form-model-item>
      <a-form-model-item label="医师形象照片" prop="logo" >
        <file-upload type="image" :defaultList="form.logoArr" :count="1"
                     @input="getImg($event, 'logo')"/>
      </a-form-model-item>
      <a-form-model-item label="工龄" prop="workYear" >
        <a-input-number :min="0" v-model="form.workYear" placeholder="请输入工龄" />年
      </a-form-model-item>
      <a-form-model-item label="职称" prop="professional" >
        <a-select v-model="form.professional" placeholder="请选择">
          <a-select-option v-for="item in dict.type['doctor_professional']" :value="item.value" :key="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="固定荣誉" prop="fixedHonors">
        <a-checkbox :checked="form.honorTypes.includes(1)" @change="handleFixedHonorChange(1)">
          国内名医
        </a-checkbox>
        <a-checkbox :checked="form.honorTypes.includes(2)" @change="handleFixedHonorChange(2)">
          省内名医
        </a-checkbox>
      </a-form-model-item>
      <a-form-model-item label="自定义荣誉" prop="customHonors">
        <div v-for="(honor, index) in form.customHonors" :key="index" style="margin-bottom: 8px;">
          <a-input
            v-model="form.customHonors[index]"
            placeholder="请输入自定义荣誉名称"
            style="width: calc(100% - 80px); margin-right: 8px;"
          />
          <a-button type="danger" size="small" @click="removeCustomHonor(index)" v-if="form.customHonors.length > 1">
            删除
          </a-button>
        </div>
        <a-button type="dashed" size="small" @click="addCustomHonor" style="width: 100%;">
          <a-icon type="plus" /> 添加自定义荣誉
        </a-button>
      </a-form-model-item>
      <a-form-model-item label="荣誉凭证" prop="certificateArr">
        <file-upload
          type="image"
          :defaultList="form.certificateArr"
          :count="9"
          @input="getImg($event, 'certificate')"/>
      </a-form-model-item>
      <a-form-model-item label="擅长领域" prop="strongPoint" >
        <a-input v-model="form.strongPoint" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="个人简介" prop="content" >
        <editor ref="contentEditor" v-model="form.content" :min-height="192" editor-id="doctor-content-editor"/>
      </a-form-model-item>
<!--      <a-form-model-item label="华歧系数" prop="score" >-->
<!--        <a-input-number :min="0" v-model="form.score" placeholder="请输入华歧系数" />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDoctor, addDoctor, updateDoctor } from '@/api/doctor/doctor'
import Editor from '@/components/Editor'
import FileUpload from '@/components/FileUpload'
import { guid } from '@/utils/ruoyi'
import { getHospital, pageHospital } from '@/api/hospital/hospital'
import { listDepart } from '@/api/hospital/depart'
import { processImageUrl } from '@/utils/util'

import TableSelectModal from '@/components/TableSelectModal'

export default {
  name: 'CreateForm',
  dicts: ['sys_user_sex', 'doctor_professional', 'doctor_honor'],
  props: {
  },
  components: {
    Editor,
    FileUpload,
    TableSelectModal
  },
  computed: {
    // 动态生成医院表格列
    hospitalColumns() {
      return [
        {
          title: '医院名称',
          dataIndex: 'hospitalName',
          ellipsis: true,
          width: 200
        },
        {
          title: '地区',
          dataIndex: 'areaName',
          width: 150
        },
        {
          title: '医院等级',
          dataIndex: 'level',
          width: 100
        },
        {
          title: '医院性质',
          dataIndex: 'nature',
          width: 100
        },
        {
          title: '医院类型',
          dataIndex: 'type',
          width: 100
        }
      ]
    }
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      hospitalList:[],
      departList:[],
      hospitalSelectVisible: false,
      hospitalName: '',
      // 表单参数
      form: {
        id: null,
        userId: null,
        doctorAuthId: null,
        hospitalId: null,
        departId: null,
        name: null,
        sex: null,
        certify: null,
        certifyArr: [],
        certifyCount: 1,
        logo: null,
        logoArr: [],
        logoCount: 6,
        certificateArr: [],
        certificateCount: 9,
        workYear: null,
        professional: null,
        honor: null,
        honorTypes: [], // 固定荣誉类型：1-国内名医 2-省内名医
        customHonors: [], // 自定义荣誉
        honorList:[],
        strongPoint: null,
        content: null,
        certificate: null,
        score: null,
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        hospitalId: [
          { required: true, message: '医院不能为空', trigger: 'blur' }
        ],
        departId: [
          { required: true, message: '科室不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '性别不能为空', trigger: 'change' }
        ],
        // certify: [
        //   { required: true, message: '行医资质证明不能为空', trigger: 'blur' }
        // ],
        // logo: [
        //   { required: true, message: '医师形象照片不能为空', trigger: 'blur' }
        // ],
        workYear: [
          { required: true, message: '工龄不能为空', trigger: 'blur' }
        ],
        professional: [
          { required: true, message: '职称不能为空', trigger: 'blur' }
        ],
        // honor: [
        //   { required: true, message: '获得荣誉不能为空', trigger: 'blur' }
        // ],
        // strongPoint: [
        //   { required: true, message: '擅长领域不能为空', trigger: 'blur' }
        // ],
        // content: [
        //   { required: true, message: '个人简介不能为空', trigger: 'blur' }
        // ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  activated () {
    this.initData()
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    pageHospital,

    initData(){
    },
    changeHospital(val){
      this.form.hospitalId = val
      listDepart({hospitalId:val}).then(res=>{
        this.departList = res.data
      })
    },
    // 打开医院选择弹窗
    handleSelectHospital () {
      this.hospitalSelectVisible = true
    },

    // 医院选择确定
    handleHospitalSelected (hospital) {
      this.form.hospitalId = hospital.id
      this.hospitalName = hospital.hospitalName
      this.hospitalSelectVisible = false
      // 加载该医院的科室列表
      listDepart({hospitalId: hospital.id}).then(res=>{
        this.departList = res.data
      })
    },

    // 医院选择取消
    handleHospitalCancel () {
      this.hospitalSelectVisible = false
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].halfUrl
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.halfUrl }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.hospitalName = ''
      this.form = {
        id: null,
        userId: null,
        doctorAuthId: null,
        hospitalId: null,
        departId: null,
        name: null,
        sex: null,
        certify: null,
        certifyArr: [],
        certifyCount: 1,
        logo: null,
        logoArr: [],
        logoCount: 6,
        certificateArr: [],
        certificateCount: 9,
        workYear: null,
        professional: null,
        honor: null,
        honorTypes: [],
        customHonors: [''],
        honorList:[],
        strongPoint: null,
        content: null,
        certificate: null,
        score: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      // 初始化荣誉相关字段
      this.$set(this.form, 'honorTypes', [])
      this.$set(this.form, 'customHonors', [''])
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDoctor({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
        let that = this
        this.form.logoArr = []
        this.form.certifyArr = []
        this.form.certificateArr = []

        // 处理荣誉回显：从逗号分隔的字符串中解析
        this.$set(this.form, 'honorTypes', [])
        this.$set(this.form, 'customHonors', [])

        if (this.form.honor) {
          const honorList = this.form.honor.split(',').map(item => item.trim())
          const honorTypes = []
          const customHonorList = []

          honorList.forEach(item => {
            if (item === '国内名医') {
              honorTypes.push(1)
            } else if (item === '省内名医') {
              honorTypes.push(2)
            } else if (item) {
              customHonorList.push(item)
            }
          })

          this.$set(this.form, 'honorTypes', honorTypes)
          this.$set(this.form, 'customHonors', customHonorList.length > 0 ? customHonorList : [''])
        } else {
          this.$set(this.form, 'honorTypes', [])
          this.$set(this.form, 'customHonors', [''])
        }

        // 处理荣誉凭证回显
        if(this.form.certificate){
          this.form.certificate.split(',').forEach(item =>{
            that.form.certificateArr.push({
              uid: guid(8, 10),
              name: item,
              status: 'done',
              halfUrl: item,
              url: processImageUrl(item),
              path: item
            })
          })
        }

        if(this.form.certify){
          that.form.certifyArr.push({
            uid: guid(8, 10),
            name: that.form.certify,
            status: 'done',
            halfUrl: that.form.certify,
            url: processImageUrl(that.form.certify),
            path: that.form.certify
          })
        }
        if(this.form.logo){
          this.form.logoArr.push({
            uid: guid(8, 10),
            name: that.form.logo,
            status: 'done',
            halfUrl: that.form.logo,
            url: processImageUrl(that.form.logo),
            path: that.form.logo
          })
        }
        // 回显医院名称
        if (this.form.hospitalId) {
          this.loadHospitalName(this.form.hospitalId)
        }
        // 加载科室列表
        this.changeHospital(this.form.hospitalId)
        console.log('this.form', this.form)
      })
    },

    // 加载医院名称用于回显
    loadHospitalName(hospitalId) {
      getHospital({ id: hospitalId }).then(res => {
        if (res.data) {
          this.hospitalName = res.data.hospitalName
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true

          // 处理荣誉数据：使用逗号分隔的字符串格式
          const honorList = []

          // 固定荣誉放在最前面：国内名医 > 省内名医
          if (this.form.honorTypes && this.form.honorTypes.length > 0) {
            // 先排序，国家级在前
            const sortedTypes = [...this.form.honorTypes].sort((a, b) => a - b)
            sortedTypes.forEach(type => {
              if (type === 1) {
                honorList.push('国内名医')
              } else if (type === 2) {
                honorList.push('省内名医')
              }
            })
          }

          // 自定义荣誉（过滤空值）
          if (this.form.customHonors && this.form.customHonors.length > 0) {
            const customHonors = this.form.customHonors.filter(h => h && h.trim() !== '')
            honorList.push(...customHonors)
          }

          // 转为逗号分隔的字符串
          this.form.honor = honorList.length > 0 ? honorList.join(',') : null

          if (this.form.id !== undefined && this.form.id !== null) {
            updateDoctor(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addDoctor(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    // 添加自定义荣誉
    addCustomHonor () {
      this.form.customHonors.push('')
    },
    // 删除自定义荣誉
    removeCustomHonor (index) {
      this.form.customHonors.splice(index, 1)
      // 如果删除了最后一个，添加一个空项
      if (this.form.customHonors.length === 0) {
        this.form.customHonors.push('')
      }
    },
    // 处理固定荣誉变化
    handleFixedHonorChange (type) {
      const index = this.form.honorTypes.indexOf(type)
      if (index > -1) {
        // 已存在，取消选择
        this.form.honorTypes.splice(index, 1)
      } else {
        // 不存在，添加选择
        this.form.honorTypes.push(type)
      }
      // 强制更新视图
      this.$set(this.form, 'honorTypes', [...this.form.honorTypes])
    }
  }
}
</script>
